import { GetVenueOverviewVersionsResponseType as ApiGetVenueOverviewVersionsResponseType } from 'src/api/generated/touring/types';
import { VenueOverviewVersionsResponseType } from './types';

export const mapVenueOverviewVersionsResponseType = (
  apiType: ApiGetVenueOverviewVersionsResponseType
): VenueOverviewVersionsResponseType => {
  return apiType.data;
};

